// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setWeek as fn } from "../setWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setWeekWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default setWeekWithOptions;
